import React, { CSSProperties } from 'react';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import styled from 'styled-components';

interface SelectIconProps {
  children: any;
  style?: CSSProperties;
  className?: string;
  variant?: 'small' | 'medium';
}

export const SelectIconWrapper: React.FC<React.PropsWithChildren<SelectIconProps>> = ({
  children,
  style,
  className,
  variant = 'medium'
}) => (
  <StyledListItemAvatar style={style} className={className} $variant={variant}>
    {children}
  </StyledListItemAvatar>
);

const StyledListItemAvatar = styled(ListItemAvatar)<{ $variant: 'small' | 'medium' }>`
  && {
    min-width: ${({ $variant }) => ($variant === 'small' ? 26 : 36)}px;
    display: inline-block;
    vertical-align: middle;
    & > * {
      vertical-align: middle;
      height: ${({ $variant }) => ($variant === 'small' ? 18 : 24)}px;
      width: ${({ $variant }) => ($variant === 'small' ? 18 : 24)}px;
    }
  }
`;
